/*Recurso: Files - Variables y rutinas store que almacenan la respuesta del API y su manipulación en el front
  Tareas:
    GetSummaryPxF              //*RD
    GetDetailbyProcess         //*RD   
    GetRateProposal            //*RD   
    UpdateRateProposal         //*RD  
    SendRateProposal           //*RD
*/
//elementos stores: elementos que llenamos con inf. del api y otros elementos captados del front o para manejo del front
//funciones stores: rutinas que captan o modifican los elementos store
//response: { config: {}, hearders:{}, request:{}, data: { informacion: {}, resultado: {}, contenido: [{ }] } } //esto trae la lectura de api

import create from "zustand";

const decisionsStore = create((set:any, get:any) => ({
 
  objErrorDecisionsStore: { hasError: false, url: '', body:'',  recurso:"decisions", componente:'', idresul: 0, desresul:'', menu:''}, //se llena con la información del api si éste tiene error
  
    //*Limpia objeto de error cuando éste ya se mostro en VentanaObjeErrorAPI  
    limpiaObjErrorDecisionsStore: () => {
      let paso = { hasError: false, url:'', body:'', recurso:'decisions', componente:'', idresul:0, desresul:'', menu:''}
      set( { objErrorDecisionsStore: paso } );
      //console.log('limpiaObjErrorDecisionsStore (sale) - objErrorDecisionsStore: ', get().objErrorDecisionsStore);
    },
                
    //*Error en api // entra a esta función cuando el servicio cae en catch y muestra el error en VentanaObjError
    generaObjErrorDecisionsStore: async (responseAPI:any, h:any, h2:any, e:any, c:any, m:any) => {
      //console.log('*generaObjErrorDecisionsStore (entra): ', responseAPI);
      //console.log('*generaObjErrorDecisionsStore (entra): h: ', h , ' h2: ',  h2 , ' e: ', e , ' c: ', c );
      let paso = { hasError: h, url:'', body:e, recurso:'decisions', componente:c, idresul:0, desresul:'', menu:m };
      if (responseAPI==undefined  || responseAPI=='Error: Network Error'){
          paso.idresul=-1;
          paso.desresul= 'Error inesperado, asegure su conexión con internet y vpn';
      }
      else if (responseAPI=='Error detectado por api en ret') {
        paso.desresul= h;
        paso.idresul= h2; 
      }
      else {
        let temp = responseAPI.config;
        paso.url = temp.url;
        if (responseAPI.data!="" && responseAPI.data!=null){
            paso.idresul=responseAPI.data.ret;
            paso.desresul= responseAPI.data.msjerror;
        }    
        else {
            paso.idresul= responseAPI.status;
            switch(responseAPI.status){
              //case 404:  paso.desresul= "El usuario no existe"; break;
              case 401:  paso.desresul= "No autorizado"; break;
              case 404:  paso.desresul= "No tiene información, error al leer la tarea del API"; break;
              default: paso.desresul= responseAPI.statusText; break;
            }
        }    
      }
      set( { objErrorDecisionsStore: paso } );
      console.log('::DecisionsStore - generaObjErrorDecisionsStore (sale) - objErrorDecisionsStore: ', get().objErrorDecisionsStore);
    },

  pxfStore:[],  //guarda la lista de los procesos/frecuencia

    //*Tareas: GetSummaryPxF  // lista de procesos/frecuencia
    guardaGetSummaryPxFStore: async (responseAPI:any, catPtCiclos:any) => { 
      //console.clear();
      //console.log('guardaGetSummaryPxFStore - responseAPI:', responseAPI)
      console.log('************guardaGetSummaryPxFStore - catPtCiclos:', catPtCiclos)
      var _ = require('underscore');
      if (responseAPI.ret==1) { //sin error
        set ( { pxfStore: responseAPI.item } );
        get().pxfStore.map((pxf:any, indexpxf:any) => {
            pxf.abierto = false; //por omisión entra cerrado
            pxf.pxfNombre = pxf.acronym + ' / ' + pxf.frequencyname;
            pxf.totalPropuestas = pxf.inprocess + pxf.accepted;
            pxf.idxOrdAnt=-1;
            pxf.ColOrd='folio';
            pxf.AscDes=true;
            
            let paso = pxf.state_process;
            pxf.estatusProceso = paso.pt_state_description;
            pxf.clasexEstatusIcono = "";
            switch ( paso.pt_state ) {
              case 1: pxf.clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
              case 2: pxf.clasexEstatusIcono = "claseEstatus claseEstatusEdi"; break;
              case 3: pxf.clasexEstatusIcono = "claseEstatus claseEstatusIna"; break;
              case 4: pxf.clasexEstatusIcono = "claseEstatus claseEstatusHis"; break;
              default: pxf.clasexEstatusIcono= "claseEstatus claseEstatusAct"; break;
            }
            
            //generemos el arreglo de ciclos acorde al pxf seleccionado vs. idpf del catálogo de ciclos integrado

            pxf.misCiclos=[];

            console.log('************pxf.id:', pxf.id)

            let ciclosDelProceso = _.filter(catPtCiclos, function(cy:any) { return cy.idpf== pxf.id });

            console.log('************ciclosDelProceso:', ciclosDelProceso)

            let hash:any = {};
            let ciclosNoRepetidos:any = _.filter(ciclosDelProceso, function(o:any) { return hash[o.id] ? false : hash[o.id] = true });
            console.log ('1-----:::hash: ', hash );
            console.log ('2-----:::ciclosNoRepetidos: ', ciclosNoRepetidos );
            ciclosNoRepetidos.map((c:any, indexc:any) => {
              c.activo=false;
              c.disabled=false;
              c.visible=true;
            });
            pxf.misCiclos = ciclosNoRepetidos;
            console.log ('3-----:::pxf.misCiclos: ', pxf.misCiclos );
            pxf.misCiclos.unshift( {"idPF": null, "id":0, "name": "Seleccionar", activo:false, disabled:false, visible:true});
            pxf.misCiclos.push( {"idPF": null,"id":99999, "name": "Otro",  "description": "", activo:false, disabled:false, visible:true});
            console.log ('4-----:::pxf.misCiclos: ', pxf.misCiclos );
            pxf.opcCiclos = pxf.misCiclos[0];
           
            pxf.misPropuestas=[];
        });
      
        console.log (':::pxfStore: ', get().pxfStore );
        return(get().pxfStore);
      }
      else {
        get().generaObjErrorDecisionsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'decisions.store-guardaGetSummaryPxFStore')
      }
    },

    //*Lo llamamos desde useEffect (RP-Responsable de Proceso) solo cuando se actualizo la decisión de una propuesta
    // y esta agrego un ciclo nuevo
    actualizaCiclosStore: async (idpxf:any, catPtCiclos:any) => {
      //console.log (':::actualizaCiclosStore:  idpxf', idpxf, '  catPtCiclos: ', catPtCiclos);
      var _ = require('underscore');
      get().pxfStore.map((pxf:any, indexpxf:any) => {
        if (pxf.id == idpxf) {
          pxf.misCiclos=[];
          let ciclosDelProceso = _.filter(catPtCiclos, function(cy:any) { return cy.idpf== pxf.id });
          let hash:any = {};
          let ciclosNoRepetidos:any = _.filter(ciclosDelProceso, function(o:any) { return hash[o.id] ? false : hash[o.id] = true });
          //console.log ('1-----:::hash: ', hash );
          //console.log ('2-----:::ciclosNoRepetidos: ', ciclosNoRepetidos );
          ciclosNoRepetidos.map((c:any, indexc:any) => {
            c.activo=false;
            c.disabled=false;
            c.visible=true;
          });
          pxf.misCiclos = ciclosNoRepetidos;
          //console.log ('3-----:::pxf.misCiclos: ', pxf.misCiclos );
          pxf.misCiclos.unshift( {"idPF": null, "id":0, "name": "Seleccionar", activo:false, disabled:false, visible:true});
          pxf.misCiclos.push( {"idPF": null,"id":99999, "name": "Otro",  "description": "", activo:false, disabled:false, visible:true});
          //console.log ('4-----:::pxf.misCiclos: ', pxf.misCiclos );
          pxf.opcCiclos = pxf.misCiclos[0];

        }
      }) 
      //console.log ('pxfStore: ', get().pxfStore ); 
    },
   
  pxfPropuestasStore:[],  
    //*Tareas: GetDetailbyProcess 
    // recibe las propuestas asignadas del pxf
    guardaGetDetailbyProcessStore: async (responseAPI:any, idpxf:any) => { 
      if (responseAPI.ret==1) { //sin error
        set ( { pxfPropuestasStore: responseAPI.item } );
        get().pxfPropuestasStore.map((p:any, indexp:any) => {
            p.abierto = false; //por omisión entra cerrado
            if (p.sent) { p.sentOrden = "1" }
            else { p.sentOrden = "2" };
            p.miPropuestaDetalle = {};
            p.decisionOrden = (p.decision.name!=null) ? p.decision.name : '';
            p.cycleOrden = (p.decision.cycle.name!=null) ? p.decision.cycle.name : '';

        });
        get().cambiapxfStore( idpxf, null, true, get().pxfPropuestasStore, 'guardaGetDetailbyProcessStore')
        //console.clear();
        //console.log (':::pxfPropuestasStore: ', get().pxfPropuestasStore );
        //console.log (':::pxfStore: ', get().pxfStore );
        return(get().pxfPropuestasStore);
      }
      else {
        get().generaObjErrorDecisionsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'decisions.store-guardaGetDetailbyProcessStore')
      }
    },

    cambiapxfStore: async ( idpxf:any, idprop: any, abierto:any, detalle:any, dondeViene:any ) => { 
      //alert('cambiapxfStore - index: ' + index + '  abierto: ' + abierto + ' detalle: '+ detalle + ' dondeViene: ' + dondeViene)
      //console.log('**cambiapxfStore - idpxf: ', idpxf ,'  idprop: ', idprop, ' dondeViene: ', dondeViene);
      //console.log('cambiapxfStore - detalle: ', detalle )
      switch (dondeViene){
          case 'guardaGetDetailbyProcessStore': 
                  get().pxfStore.map((pxf:any, indexpxf1:any) => {
                    if (pxf.id==idpxf) { 
                        pxf.misPropuestas = detalle;
                        pxf.abierto = abierto;
                    }    
                  }); 
                break;
          case 'guardaGetRateProposalStore':  
                  get().pxfStore.map((pxf:any, indexpxf2:any) => {
                    if (pxf.id==idpxf) { 
                          pxf.misPropuestas.map((mp:any, indexmp2:any) => {
                          if (mp.id==idprop)
                              mp.miPropuestaDetalle = detalle;
                        }); 
                    }
                  }); 
                break;
          case 'abreCierraPxF':  
                  get().pxfStore.map((p:any, indexp:any) => {
                    if (p.id==idpxf) 
                        p.abierto = abierto;
                  }); 
                break;
          case 'botonEnviar':  
                  get().pxfStore.map((p:any, indexp2:any) => {
                    if (p.id==idpxf) { 
                        p.send = true;
                        p.abierto = false;
                    }    
                  }); 
                break;
          case 'botonGuardarAPI': 
                let paso:any = {};
                get().pxfStore.map((pxf:any, indexpxf3:any) => {
                  if (pxf.id==idpxf) { 
                      pxf.misPropuestas.map((mp:any, indexmp3:any) => {
                        if (mp.id==idprop) { 
                            mp.decision = detalle;
                            mp.decisionOrden =  detalle.name;
                            paso = detalle.cycle;
                            if (paso != null)
                                mp.cycleOrden = paso.name
                        }
                      })
                  }    
                });  
              break;
          case 'botonEnviarAPI': 
                get().pxfStore.map((pxf:any, indexpxf4:any) => {
                  if (pxf.id==idpxf) { 
                      pxf.misPropuestas.map((mp:any, indexmp4:any) => {
                        if (mp.id==idprop) {  
                            mp.sent = true;
                            mp.sentOrden = detalle.sentOrden;
                        }    
                      })
                  }    
                });  
              break;              
          case 'botonGuardarCambiaBtnEnviar':  
                  get().pxfStore.map((pxf:any, indexpxf5:any) => {
                    if (pxf.id==idpxf) {
                        pxf.misPropuestas.map((mp:any, indexmp5:any) => {
                            if (mp.id==idprop) { 
                                let paso = mp.miPropuestaDetalle;
                                paso.proposal.btnEnviar = true;
                            }    
                        })
                    }     
                  }); 
                break;
      } 
      //console.clear();
      //console.log ('::*cambiapxfStore: ' );
      //console.log ('::pxfPropuestaDetalleStore: ', get().pxfPropuestaDetalleStore );
      //console.log ('::pxfPropuestasStore: ', get().pxfPropuestasStore );
      //console.log ('::pxfStore: ', get().pxfStore );
    },
    
  pxfPropuestaDetalleStore:{},
  pxfPropuestaDetalleVacia:{
    id: 0, acronym: '', processname: '', frequencyname: '', frequencyformat: '', frequencyregexp: '',
    proposal: { id: 0, folio: '', description: '', sent: false, evidence: [], quality:  [],
      decision: { id: 0, name: '', files: [], commentary: '', cycle: { id: null, name: null, state_cycle: null, pt_md: null } }
    },
    state_process: { pt_state: 1, pt_state_description: "Activo", onwaiting: false, leftdays: null },
    state_cycle: { pt_state: null, pt_state_description: null, onwaiting: null },
    pt_md: []
  },

    //*Tareas: GetRateProposal  // recibe los detalles de la propuesta seleccionada (Ver / Registrar) del pxf seleccionado
    //response.data, idpxf, idProp, tipo, pasoCatD, pasoCatP, pasoCatC, pasoCatE
    guardaGetRateProposalStore: async (responseAPI:any, idpxf:any, idprop:any, tipo:any, catD:any, catP:any, catC:any, catE:any) => { 
      console.log('*******catC',catC);
      //console.log('responseAPI', responseAPI);
      //console.log('idpxf:', idpxf, '  idprop:', idprop, ' tipo: ', tipo, '  catD:',catD, ' catP: ',  catP, ' catC: ', catC,  ' catE:', catE)
      var _ = require('underscore');

      if (responseAPI.ret==1) { //sin error
          set ( { pxfPropuestaDetalleStore: get().pxfPropuestaDetalleVacia } ) 
          set ( { pxfPropuestaDetalleStore: responseAPI.item } )
         
          //console.log(':::::pxfPropuestaDetalleStore.frequencyformat', get().pxfPropuestaDetalleStore.frequencyformat)
          //agregamos elementos extras para manejo del front
            get().pxfPropuestaDetalleStore.proposal.abierto = true;
            get().pxfPropuestaDetalleStore.proposal.btnGuardar = get().pxfPropuestaDetalleStore.sent ? null : false;
            get().pxfPropuestaDetalleStore.proposal.btnEnviar =  get().pxfPropuestaDetalleStore.sent ? null : false;
    
            //para ver etiqueta de activo en la ventana sp
            let paso = get().pxfPropuestaDetalleStore.state_process;
            //console.log(':::::::::::::paso',paso)
            get().pxfPropuestaDetalleStore.estatusProceso = paso.pt_state_description;
            get().pxfPropuestaDetalleStore.clasexEstatusIcono = "";
            switch ( paso.pt_state ) {
              case 1: get().pxfPropuestaDetalleStore.clasexEstatusIcono = "claseEstatus claseEstatusAct"; break;
              case 2: get().pxfPropuestaDetalleStore.clasexEstatusIcono = "claseEstatus claseEstatusEdi"; break;
              case 3: get().pxfPropuestaDetalleStore.clasexEstatusIcono = "claseEstatus claseEstatusIna"; break;
              case 4: get().pxfPropuestaDetalleStore.clasexEstatusIcono = "claseEstatus claseEstatusHis"; break;
              default: get().pxfPropuestaDetalleStore.clasexEstatusIcono= "claseEstatus claseEstatusAct"; break;
            }

          //ajustes para visualización en front
          let proposal = get().pxfPropuestaDetalleStore.proposal;
          let dec = proposal.decision;
          let decId = dec.id;
          let decCiclo = dec.cycle;
          let decCicloId = dec.cycle.id;
          let decCicloName = dec.cycle.name;

          //CatD (cat decisiones) //para ambos escenarios "Ver" y "Registrar"
          catD[decId-1] = dec;
          catD[decId-1].activo = true;
          catD[decId-1].disabled = false;
          catD[decId-1].visible = true;
          //console.log ('--------*************decId', decId);
      

          if ( tipo=='ver' ) { // "Ver" ya envió es solo visualización  //get().pxfPropuestaDetalleStore.proposal.sent = true
            //CatD (cat decisiones)
            catD[decId-1].disabled = true;

            //caso "NO prevista" trae archivo(s) en 'Ver'; por lo tanto, debemos agregar la ruta para que los descargue el usuario de la NAS
            if (decId == 3) {
                let rutaNAS = process.env.REACT_APP_SERV_HOSTNAME + 'docs/decision/';
                catD[decId-1].files.map((f:any, indexCatDF:any) => {
                    f.descarga = rutaNAS + f.path + '/' + f.originalfullname;
                });
            }
            //console.log ('-----------*************catD', catD);
            get().pxfPropuestaDetalleStore.proposal.miCatDecisiones = catD;

            //CatP (cat principios) 
            catP = get().pxfPropuestaDetalleStore.proposal.quality;
            catP.map((p:any, indexCatP:any) => {
                p.activo = true;
                p.disabled = true;
                p.visible = true;
                p.hitId = p.hit.id;
                p.hitName = p.hit.name;
            });
            get().pxfPropuestaDetalleStore.proposal.miCatPrincipios = catP;

            //CatC (cat ciclos) // no aplica en "Ver", su información la trae Decisiones
            get().pxfPropuestaDetalleStore.proposal.miCatCiclos = catC;

            //CatA //va ligado con "Prevista" -> "Ciclo" -> "Otro" se abre catalogo de anios
            //cuando ya se envió el catálogo va null
            get().pxfPropuestaDetalleStore.proposal.miCatAnios = null;
            
            //CatE (cat evidencias)
            catE = get().pxfPropuestaDetalleStore.proposal.evidence;
            catE.map((e:any, indexCatE:any) => {
                e.activo = true;
                e.disabled = true;
                e.visible = true;
            });
            get().pxfPropuestaDetalleStore.proposal.miCatEvidencias = catE;

            //Agrega lista de archivos a 
          }

          if ( tipo=='registrar' ) {  //  "Registrar",  a un no envía
            
            let swEnviar = true; //detecto si la plantilla esta completa para activar el botón de Enviar, por omisión es true cuando algo falta lo hago false
            
            //CatD (decisión)   //dejamos visible todos los elementos
                catD.map((d:any, indexCatD:any) => {
                  d.disabled = false;
                  d.visible = true;
                });
                //console.log('.....dec', dec)
                if (decId == 1 ) { //solo para No procede
                  if (dec.commentary == null || dec.commentary == '' ) 
                      swEnviar = false; 
                }  
                //caso "NO prevista" puede traer archivo(s) en 'Registra'; por lo tanto, debemos mostrarlos en el dropzone
                // 0-sin cambios (ya lo había guardado una vez y se queda), 1-alta, 2-baja
                if (decId == 3 ) {
                  if (catD[decId-1].files.length > 0) {
                      catD[decId-1].files.map((f:any, indexCatDF:any) => {
                          f.action = 0;  //cuando asignamos asumimos que no hay cambios
                      });
                  }    
                  else { swEnviar = false };  
                }
                //console.log ('*************catD', catD);
            get().pxfPropuestaDetalleStore.proposal.miCatDecisiones = catD;
            //console.log ('1*************swEnviar', swEnviar);
            

            //CatC (ciclos)
              if (decId != 1 ) { //el ciclo se asigna solo a Prevista y No Prevista
                  get().pxfPropuestaDetalleStore.proposal.otroCiclo = false; //entra por omisión, si se detecta se activa
                  
                  // no se ha asigndado decisión 
                  if (decCicloId == null && decCicloName == null){  
                    catC[0].activo = true; // se asigna el primer elemento por omisión del catálogo de ciclos "Seleccionar"
                    swEnviar = false
                  }

                  //selecciono un elemento de "Ciclo"
                  if (decCicloId != null && decCicloName != null) { 
                      catC.map((c:any, indexC:any) => {
                          c.visible = true;
                          if (c.id==decCicloId) { c.activo = true }    
                      }); 
                  }

                  //Selecciono de "Ciclo" la opción "Otro", se activa combo "Periodo"
                  if (decCicloId == null && decCicloName != null) { 
                      catC[catC.length-1].activo = true;  //combo "Ciclo" = otro
                      get().pxfPropuestaDetalleStore.proposal.otroCiclo = true; 
                        //console.log ('get().pxfPropuestaDetalleStore.frequencyformat...',get().pxfPropuestaDetalleStore.frequencyformat);
                        //console.log ('decCiclo.name...',decCiclo.name);
                  }
              }
            get().pxfPropuestaDetalleStore.proposal.miCatCiclos = catC;
            //console.log ('2*************swEnviar ', swEnviar);        

            //CatCO //va ligado con "Prevista" y "No prevista" -> "Ciclo" -> "Otro" se abre catalogo de "Periodos"
            //generamos catCO Catálogo de Ciclos alternativos, se genera 30 años arriba y abajo acorde a su frecuencia
            //aprovechamos y activamos si traemos de api un periodo 
            let catCO = new Array();
            let catCOhh = new Array();
            let catCOhhmm = new Array();
            let catCOAA = new Array();
            let catCOMM = new Array();
            let catCODD = new Array();
           
            let date = new Date();
            let aaIni =  2015 //date.getFullYear() - 30;
            let aaFin =  date.getFullYear() + 10; //date.getFullYear() + 30;
            let paso:any = {id:'', name:'', activo:false};
           
            let swActivo = false;
            get().pxfPropuestaDetalleStore.frecuenciaHH = false;
            get().pxfPropuestaDetalleStore.frecuenciaHHMM = false;
            get().pxfPropuestaDetalleStore.frecuenciaUND = false; //frecuencia Unica o No Determinado
            let cuenta = 0;
            let swActivoHH = true; //lo uso para activar el "Seleccionar" primer elemento
            let swActivoHHMM = true; //lo uso para activar el "Seleccionar" primer elemento
            let swActivoAA = true;
            let swActivoMM = true;
            let swActivoDD = true;

            //genero combo para 'Otros' cuando se selecciona en ciclo   
            let miFrecuencia = '';
            if (catC.length == 2) { //NO trae ciclo: [0]='Seleccionar', [1]='Otro', por lo tanto hay que generar 3 combos'AAAA' 'MM' 'DD'
                miFrecuencia = get().pxfPropuestaDetalleStore.frequencyformat;
            }

            if (get().pxfPropuestaDetalleStore.frequencyformat == 'AAAA-MM-DD ó AAAA-MM ó AAAA') {
                if (catC.length >= 3) { //trae de menos un ciclo: [0]='Seleccionar', [n-1]='Otro',  [1..n-2]='AAAA' / 'AAAA-MM' / 'AAAA-MM-DD'
                    let x = catC[1].name;
                    switch (x.length) {
                      case 4:  miFrecuencia = 'AAAA'; break;
                      case 7:  miFrecuencia = 'AAAA-MM'; break;
                      case 10: miFrecuencia = 'AAAA-MM-DD'; break;
                    }
                }
                else { miFrecuencia = get().pxfPropuestaDetalleStore.frequencyformat}
            }
            else { miFrecuencia = get().pxfPropuestaDetalleStore.frequencyformat }
            //console.log('******* miFrecuencia',miFrecuencia);
            console.log('miFrecuencia..........', miFrecuencia)
            switch (miFrecuencia) {
              case 'AAAA': //anual // cada 10 años //cada 6 años //cada 5 años //cada 4 años //cada 3 años //cada 2 años 
                    swActivo = false;
                    cuenta = 1;
                    for (var i = aaIni; i <= aaFin; i++) {
                        paso = {id:'', name:'', activo:false};
                        cuenta = cuenta + 1;
                        paso.id = cuenta; // (i-aaIni)+1;
                        //console.log ('paso.id ',paso.id )
                        paso.name = i.toString();
                        if ( paso.name == decCiclo.name){
                            paso.activo=true;
                            swActivo = true;
                        }
                        else    
                            paso.activo=false;
                        catCO.push(paso);
                    }
                break;
              case 'AAAA-SS': //semestral
                    console.log('semestral')
                    swActivo = false;
                    cuenta = 1;
                    for (var i = aaIni; i <= aaFin; i++){ 
                        for (var j = 1; j <= 2; j++) {
                            paso = {id:'', name:'', activo:false};
                            cuenta = cuenta + 1;
                            paso.id = cuenta; // (i-aaIni)+1;
                            paso.name = i.toString() + '-' + `0${j}`;
                            if ( paso.name == decCiclo.name){
                                paso.activo=true;
                                swActivo = true;
                            }
                            else    
                                paso.activo=false;
                            catCO.push(paso);
                          
                        }
                    }
                  break;
              case 'AAAA-TT': //trimestal
                    swActivo = false;
                    cuenta = 1;
                    for (var i = aaIni; i <= aaFin; i++) {
                        for (var j = 1; j <= 4; j++) {
                            paso = {id:'', name:'', activo:false};
                            cuenta = cuenta + 1;
                            paso.id = cuenta; // (i-aaIni)+1;
                            paso.name = i.toString() + '-' + `0${j}`;
                            if ( paso.name ==decCiclo.name){
                                paso.activo=true;
                                swActivo = true;
                            }
                            else    
                                paso.activo=false;
                            catCO.push(paso);
                        }
                    }
                  break;
              case 'AAAA-BB': //bimestral
                    swActivo = false;
                    cuenta = 1;
                    for (var i = aaIni; i <= aaFin; i++) { 
                        for (var j = 1; j <= 6; j++) {
                            paso = {id:'', name:'', activo:false};
                            cuenta = cuenta + 1;
                            paso.id = cuenta; // (i-aaIni)+1;
                            paso.name = i.toString() + '-' + `0${j}`;
                            if ( paso.name == decCiclo.name){
                                paso.activo=true;
                                swActivo = true;
                            }
                            else    
                                paso.activo=false;
                            catCO.push(paso);
                        }
                    }
                break;
              case 'AAAA-MM': //mensual
                    swActivo = false;
                    cuenta = 1;
                    for (var i = aaIni; i <= aaFin; i++) {
                        for (var j = 1; j <= 12; j++) {
                            paso = {id:'', name:'', activo:false};
                            cuenta = cuenta + 1;
                            paso.id = cuenta; // (i-aaIni)+1
                            paso.name = (j<10) ? i.toString() + '-' + `0${j}` 
                                               : i.toString() + '-' + `${j}`;
                            if ( paso.name == decCiclo.name){
                                paso.activo=true;
                                swActivo = true;
                            }
                            else    
                                paso.activo=false;
                            catCO.push(paso);
                        }
                    }
                  break;
              case 'AAAA-QQ': //24 qnas por año
                    swActivo = false;
                    cuenta = 1;
                    for (var i = aaIni; i <= aaFin; i++){ 
                        for (var j = 1; j <= 24; j++) {
                            paso = {id:'', name:'', activo:false};
                            cuenta = cuenta + 1;
                            paso.id = cuenta; // (i-aaIni)+1
                            paso.name = (j<10) ? i.toString() + '-' + `0${j}` 
                                              : i.toString() + '-' + `${j}`;
                            if ( paso.name == decCiclo.name){
                                paso.activo=true;
                                swActivo = true;
                            }
                            else    
                                paso.activo=false;
                            catCO.push(paso);
                        } 
                    }
                break;
              case 'AAAA-W': //cada 6 semanas (8 por año)
                  swActivo = false;
                  cuenta = 1;
                  for (var i = aaIni; i <= aaFin; i++){ 
                      for (var j = 1; j <= 8; j++) {
                          paso = {id:'', name:'', activo:false};
                          cuenta = cuenta + 1;
                          paso.id = cuenta; // (i-aaIni)+1
                          paso.name = i.toString() + '-' + `0${j}`;
                          if ( paso.name == decCiclo.name){
                              paso.activo=true;
                              swActivo = true;
                          }
                          else    
                              paso.activo=false;
                          catCO.push(paso);
                      } 
                  }
                break;
              case 'AAAA-WW': //semanal (52 por año)
                    swActivo = false;
                    cuenta = 1;
                    for (var i = aaIni; i <= aaFin; i++){ 
                        for (var j = 1; j <= 52; j++) {
                            paso = {id:'', name:'', activo:false};
                            cuenta = cuenta + 1;
                            paso.id = cuenta; // (i-aaIni)+1
                            paso.name = (j<10) ? i.toString() + '-' + `0${j}` 
                                              : i.toString() + '-' + `${j}`;
                            if ( paso.name == decCiclo.name){
                                paso.activo=true;
                                swActivo = true;
                            }
                            else    
                                paso.activo=false;
                            catCO.push(paso);
                        } 
                    }
                  break;
              case 'AAAA-MM-DD': //diaria //ojo no se probo con datos reales
                    swActivo = false;
                    cuenta = 1;
                    for (var i=aaIni; i<=aaFin; i++) {
                        for (var j=1; j<=12; j++) {
                            let kTotal = 0;
                            let esBisiesto = false;
                            if ( j== 1 || j== 5 || j== 7 || j== 8 || j== 10 || j== 12 ) { kTotal = 31 }
                            if ( j== 3 || j== 4 || j== 6 || j== 9 || j== 11 ) { kTotal = 30 }
                            if ( j== 2 ) {
                                esBisiesto = (i % 400 === 0) ? true : (i % 100 === 0) ? false : i % 4 === 0;
                                kTotal = (esBisiesto) ? 29 : 28
                            }
                            for (var k = 1;  k <= kTotal; k++) {
                                paso = {id:'', name:'', activo:false};
                                cuenta = cuenta + 1;
                                paso.id = cuenta;
                                //console.log('...',paso.id);
                                paso.name = (j<10) ? (k<10) ? i.toString() + '-' + `0${j}` + '-' + `0${k}` 
                                                            : i.toString() + '-' + `0${j}` + '-' + `${k}` 
                                                   : (k<10) ? i.toString() + '-' + `${j}` + '-'  + `0${k}` 
                                                            : i.toString() + '-' + `${j}` + '-'  + `${k}`;

                                if ( paso.name == decCiclo.name){
                                    paso.activo=true;
                                    swActivo = true;
                                }
                                else    
                                    paso.activo=false;
                                catCO.push(paso);
                            }
                        }
                    }
                    //console.log('cuenta..',cuenta)
                break;
              case 'AAAA-MM-DD hh': // hh//diaria //ojo no se probo con datos reales
                    get().pxfPropuestaDetalleStore.frecuenciaHH = true;
                    get().pxfPropuestaDetalleStore.frecuenciaHHMM = false;
                    let decCicloHH = {id:'', name:'', activo:false};
                    let cadena = JSON.parse(JSON.stringify(dec.cycle.name));
                    decCicloHH.name = cadena.substring(cadena.length - 2);
                    let decCicloNameHHhh = decCicloHH.name;
                    let decCicloNameHH = cadena.substring(0, cadena.length - 3);
                    //console.log('...decCicloNameHH..', decCicloNameHH);
                    //console.log('...decCicloNameHHhh..',decCicloNameHHhh);
                    swActivo = false;
                    cuenta = 1;
                    for (var i=aaIni; i<=aaFin; i++) {
                        for (var j=1; j<=12; j++) {
                            let kTotal = 0;
                            let esBisiesto = false;
                            if ( j== 1 || j== 5 || j== 7 || j== 8 || j== 10 || j== 12 ) { kTotal = 31 }
                            if ( j== 3 || j== 4 || j== 6 || j== 9 || j== 11 ) { kTotal = 30 }
                            if ( j== 2 ) {
                                esBisiesto = (i % 400 === 0) ? true : (i % 100 === 0) ? false : i % 4 === 0;
                                kTotal = (esBisiesto) ? 29 : 28
                            }
                            for (var k = 1;  k <= kTotal; k++) {
                                paso = {id:'', name:'', activo:false};
                                cuenta = cuenta + 1;
                                paso.id = cuenta;
                                paso.name = (j<10) ? (k<10) ? i.toString() + '-' + `0${j}` + '-' + `0${k}` 
                                                            : i.toString() + '-' + `0${j}` + '-' + `${k}` 
                                                   : (k<10) ? i.toString() + '-' + `${j}` + '-'  + `0${k}` 
                                                            : i.toString() + '-' + `${j}` + '-'  + `${k}`;
                                //console.log('...', paso.name.length, '...',decCicloNameHH.length );
                                if (paso.name == decCicloNameHH){
                                    //console.log('yeii');
                                    paso.activo=true;
                                    swActivo = true;
                                }
                                else    
                                    paso.activo=false;
                                catCO.push(paso);
                            }
                        }
                    }
                    //generamos combo hh 
                    for (let h=0;  h<=23; h++) {
                        paso = {id:'', name:'', activo:false};
                        paso.id = h;
                        paso.name =  (h<10) ? `0${h}` : `${h}`  ;
                        //console.log(paso.name);                                                                               
                        if ( paso.name == decCicloNameHHhh ) { paso.activo=true;  swActivoHH = false; }
                        else { paso.activo=false }
                        catCOhh.push(paso);
                    }
                    //console.log('catCOhh', catCOhh);   
                break;
              case 'AAAA-MM-DD hh:mm': // hh:mm //diaria
                    get().pxfPropuestaDetalleStore.frecuenciaHH = false;
                    get().pxfPropuestaDetalleStore.frecuenciaHHMM = true;
                    let decCicloHHMM = {id:'', name:'', activo:false};
                    let cadena1 = JSON.parse(JSON.stringify(dec.cycle.name));
                    decCicloHHMM.name = cadena1.substring(cadena1.length - 5);
                    let decCicloNameMMmm = decCicloHHMM.name;
                    let decCicloNameHHMM = cadena1.substring(0, cadena1.length - 6);
                    //console.log('...decCicloNameMM..', decCicloNameMM);
                    //console.log('...decCicloNameMMmm..',decCicloNameMMmm);
                    swActivo = false;
                    cuenta = 1;
                    for (var i=aaIni; i<=aaFin; i++) {
                        for (var j=1; j<=12; j++) {
                            let kTotal = 0;
                            let esBisiesto = false;
                            if ( j== 1 || j== 5 || j== 7 || j== 8 || j== 10 || j== 12 ) { kTotal = 31 }
                            if ( j== 3 || j== 4 || j== 6 || j== 9 || j== 11 ) { kTotal = 30 }
                            if ( j== 2 ) {
                                esBisiesto = (i % 400 === 0) ? true : (i % 100 === 0) ? false : i % 4 === 0;
                                kTotal = (esBisiesto) ? 29 : 28
                            }
                            for (var k = 1;  k <= kTotal; k++) {
                                paso = {id:'', name:'', activo:false};
                                cuenta = cuenta + 1;
                                paso.id = cuenta;
                                //console.log('...',paso.id);
                                paso.name = (j<10) ? (k<10) ? i.toString() + '-' + `0${j}` + '-' + `0${k}` 
                                                            : i.toString() + '-' + `0${j}` + '-' + `${k}` 
                                                   : (k<10) ? i.toString() + '-' + `${j}` + '-'  + `0${k}` 
                                                            : i.toString() + '-' + `${j}` + '-'  + `${k}`;
                                if ( paso.name == decCicloNameHHMM){
                                    paso.activo=true;
                                    swActivo = true;
                                }
                                else    
                                    paso.activo=false;
                                catCO.push(paso);
                            }
                        }
                    }
                  //generamos combo hh 
                    let cuenta2 = 0;
                    for (let h=0;  h<=23; h++) {
                      for (let m=0;  m<=59; m++) {
                          paso = {id:'', name:'', activo:false};
                          cuenta2 = cuenta2 + 1;
                          paso.id = cuenta2;
                          paso.name =  (h<10) ? (m<10) ? `0${h}:` + `0${m}` : `0${h}:`+ `${m}` 
                                              : (m<10) ? `${h}:`  + `0${m}` : `${h}:`+ `${m}` ;
                          //console.log(paso.name);                                                                               
                          if ( paso.name == decCicloNameMMmm) { paso.activo=true;  swActivoHHMM = false; }
                          else { paso.activo=false }
                          catCOhhmm.push(paso);
                      }
                    }
                    //console.log('catCOhhmm', catCOhhmm);   
              break;
              case "AAAA-MM-DD ó AAAA-MM ó AAAA": //Unica o Indeterminada
                    console.log('Unica o Indeterminada');
                    
                    get().pxfPropuestaDetalleStore.frecuenciaUND = true;
                    let decCicloAA = {id:'', name:'', activo:false};
                    let decCicloMM = {id:'', name:'', activo:false};
                    let decCicloDD = {id:'', name:'', activo:false};
                    let cadena2 = (dec.cycle.name != null) ? JSON.parse(JSON.stringify(dec.cycle.name)) : '';
                    let decCicloNameAA = '';
                    let decCicloNameMM = '';
                    let decCicloNameDD = '';
                    if (cadena2.length > 0) {
                      switch(cadena2.length){
                        case 4:  decCicloNameAA = cadena2; get().frecUNDStore[0].activo= true; get().frecUNDSelecStore = 'Anual'; break;
                        case 7:  decCicloNameMM = cadena2; get().frecUNDStore[1].activo= true; get().frecUNDSelecStore = 'Mensual'; break;
                        case 10: decCicloNameDD = cadena2; get().frecUNDStore[2].activo= true; get().frecUNDSelecStore = 'Diaria'; break;
                      }
                    }
                    console.log('..aa..',decCicloNameAA, '..mm..',decCicloNameMM, '..dd..',decCicloNameDD )
                    swActivo = false;
                   
                    let cuentaMM = 1;
                    let cuentaDD = 1;
                    let pasoAA:any = {id:'', name:'', activo:false};
                    let pasoMM:any = {id:'', name:'', activo:false};
                    let pasoDD:any = {id:'', name:'', activo:false};

                    //para AA
                    for (var i=aaIni; i<=aaFin; i++) {
                          pasoAA = {id:'', name:'', activo:false};
                          pasoAA.id = (i-aaIni)+1;
                          //console.log ('paso.id ',paso.id )
                          pasoAA.name = i.toString();
                          if ( pasoAA.name == decCicloNameAA ) { pasoAA.activo=true;  swActivoAA = false; }
                          else { pasoAA.activo=false }
                          catCOAA.push(pasoAA);
                          
                          //para MM
                          for (var j=1; j<=12; j++) {
                              pasoMM = {id:'', name:'', activo:false};
                              cuentaMM = cuentaMM + 1;
                              pasoMM.id = cuentaMM;
                              pasoMM.name = (j<10) ? i.toString() + '-' + `0${j}` 
                                                   : i.toString() + '-' + `${j}`;
                              if ( pasoMM.name == decCicloNameMM ) { pasoMM.activo=true;  swActivoMM = false; }
                              else { pasoMM.activo=false }
                        
                              catCOMM.push(pasoMM);

                              //para DD
                                let kTotal = 0;
                                let esBisiesto = false;
                                if ( j== 1 || j== 5 || j== 7 || j== 8 || j== 10 || j== 12 ) { kTotal = 31 }
                                if ( j== 3 || j== 4 || j== 6 || j== 9 || j== 11 ) { kTotal = 30 }
                                if ( j== 2 ) {
                                    esBisiesto = (i % 400 === 0) ? true : (i % 100 === 0) ? false : i % 4 === 0;
                                    kTotal = (esBisiesto) ? 29 : 28
                                }
                                for (var k = 1;  k <= kTotal; k++) {
                                    pasoDD = {id:'', name:'', activo:false};
                                    cuentaDD = cuentaDD + 1;
                                    pasoDD.id = cuentaDD;
                                    //console.log('...',paso.id);
                                    pasoDD.name = (j<10) ? (k<10) ? i.toString() + '-' + `0${j}` + '-' + `0${k}` 
                                                                  : i.toString() + '-' + `0${j}` + '-' + `${k}` 
                                                         : (k<10) ? i.toString() + '-' + `${j}` + '-'  + `0${k}` 
                                                                  : i.toString() + '-' + `${j}` + '-'  + `${k}`;
                                    if ( pasoDD.name == decCicloNameDD ) { pasoDD.activo=true;  swActivoDD = false; }
                                    else { pasoDD.activo=false }
                                        
                                    catCODD.push(pasoDD);
                                }
                          }
                    };
              break;  
            }
            //console.log('**********catCO',catCO )
            //console.log('**********swActivo',swActivo )


            if (swActivo==false) { if (decId != 1 ) { swEnviar = false } }   

            catCO.unshift( {"id":0, "name": "Seleccionar", activo:!swActivo})
            if (get().pxfPropuestaDetalleStore.frecuenciaHH) { catCOhh.unshift( {"id":0, "name": "Seleccionar", activo:swActivoHH}) }
            if (get().pxfPropuestaDetalleStore.frecuenciaHHMM) { catCOhhmm.unshift( {"id":0, "name": "Seleccionar", activo:swActivoHHMM}) }
            if (get().pxfPropuestaDetalleStore.frecuenciaUND) { 
                catCOAA.unshift( {"id":0, "name": "Seleccionar", activo:swActivoAA}) 
                catCOMM.unshift( {"id":0, "name": "Seleccionar", activo:swActivoMM}) 
                catCODD.unshift( {"id":0, "name": "Seleccionar", activo:swActivoDD}) 
            }
            get().pxfPropuestaDetalleStore.proposal.miCatCiclosOtros = catCO;
            get().pxfPropuestaDetalleStore.proposal.miCatCiclosOtrosHH = catCOhh;
            get().pxfPropuestaDetalleStore.proposal.miCatCiclosOtrosHHMM = catCOhhmm;
            get().pxfPropuestaDetalleStore.proposal.miCatCiclosOtrosAA = catCOAA;
            get().pxfPropuestaDetalleStore.proposal.miCatCiclosOtrosMM = catCOMM;
            get().pxfPropuestaDetalleStore.proposal.miCatCiclosOtrosDD = catCODD;
           
            //console.log('**********catCOAA',catCOAA );
            //console.log('**********catCOMM',catCOMM );
            //console.log('**********catCODD',catCODD );

            //CatP (principios)
            //console.clear();
              let swCatP = false;
              if (proposal.quality.length > 0) { //trae información desde api vaciamos al catálogo
                  let pasoCatP:any = [];
                  pasoCatP = _.pluck(proposal.quality, 'id');
                  catP.map((p:any, indexcatP2:any) => {
                      p.visible = true;
                      pasoCatP.map((pp:any, indexCatP:any) => {
                        if (p.id==pp) { 
                            p.activo = true;
                            p.hit = proposal.quality[indexCatP].hit;
                            p.hitId = proposal.quality[indexCatP].hit.id;
                            p.hitName = proposal.quality[indexCatP].hit.name;
                            if (p.id!=6 ) {
                                p.hitOpciones?.map((ho:any, indexho:any) => {
                                    //console.log('ho.id: ',ho.id, '... p.hit: ', p.hitId)
                                    if (p.hitId== ho.id){
                                        ho.activo = true;
                                        swCatP = true
                                    }   
                                    else
                                        ho.activo = false
                                }); 
                            } 
                            else { swCatP = true}
                        }    
                      });
                  });  
              }
             //console.log('swCatp',swCatP, 'decId--',decId)
            get().pxfPropuestaDetalleStore.proposal.miCatPrincipios = catP;
             
              if (decId == 2 && swCatP == false) { swEnviar = false } //solo Prevista trae principios

            //CatE (evidencias)
              let swCatE = false;
              if (proposal.evidence.length > 0) { //trae información desde api vaciamos al catálogo
                  let pasoCatE:any = [];
                  pasoCatE = _.pluck(proposal.evidence, 'id');
                  catE.map((e:any, indexE:any) => {
                      e.visible = true;
                      pasoCatE.map((pe:any, indexCatE:any) => {
                        if (e.id==pe) { 
                            e.activo = true;
                            swCatE = true;
                        }    
                      });
                  });  
              }
              if ( decId != 1 && swCatE== false) { swEnviar = false }; //solo Prevista y NO prevista trae evidencias
            get().pxfPropuestaDetalleStore.proposal.miCatEvidencias = catE;

            get().pxfPropuestaDetalleStore.proposal.swEnviar = swEnviar; //si es true se activa el botón de enviar "Tiene plantilla terminada"
          }

          

          get().cambiapxfStore( idpxf, idprop, true, get().pxfPropuestaDetalleStore, 'guardaGetRateProposalStore');
          console.log (':::::::::::::::::::::::::::pxfPropuestaDetalleStore: ', get().pxfPropuestaDetalleStore );
          //console.log (':::pxfStore: ', get().pxfStore );
         
        return(get().pxfPropuestaDetalleStore);
      }
      else {
         get().generaObjErrorDecisionsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'decisions.store-guardaGetRateProposalStore')
      }
    },

  updateRateProposalStore:{},

    //*Tarea: UpdateRateProposal //entra desde RP- botón: Registrar  - botón: Guardar - 
    guardaUpdateRateProposalStore: async (responseAPI:any) => {  
      //console.log('guardaUpdateRateProposalStore-responseAPI:',responseAPI)
      if ( responseAPI.ret==1 ) { //inserto sin error
          set( { updateRateProposalStore: responseAPI } );
          //console.log('updateRateProposalStore:', get().updateRateProposalStore);
          return(get().updateRateProposalStore);
      }
      else {
         get().generaObjErrorDecisionsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'decision.store-guardaUpdateRateProposalStore')
      }
    },

  sendRateProposalStore:{},
  
    //*Tarea: SendRateProposal //entra desde RP- botón: Registrar  - botón: Guardar - 
    guardaSendRateProposalStore: async (responseAPI:any) => {  
      //console.log('****guardaSendRateProposalStore-responseAPI:',responseAPI)
      if ( responseAPI.ret==1 ) { //inserto sin error
        set( { sendRateProposalStore: responseAPI } );
        //console.log('sendRateProposalStore:', get().sendRateProposalStore);
        return(get().sendRateProposalStore);
      }
      else {
        get().generaObjErrorDecisionsStore('Error detectado por api en ret', responseAPI.ret, responseAPI.msjerror, null,'decision.store-guardaSendRateProposalStore')
      }
    }, 
    
  frecUNDStore: [ {id:0, name:'Anual', activo:false }, {id:1, name:'Mensual', activo:false }, {id:2, name:'Diaria', activo:false } ],

  frecUNDSelecStore: null,

  cambiafrecUNDStore: async ( id:any ) => { 
    //console.log('cambiafrecUNDStore-id', id)
    get().frecUNDSelecStore = null;
    get().frecUNDStore.map((f:any, indexF:any) => {
        if (f.id == id) { f.activo = true; get().frecUNDSelecStore = f.name }
        else { f.activo = false }
    });  
  },

  reiniciafrecUNDStore: async ( id:any ) => { 
    //console.log('cambiafrecUNDStore-id', id)
    get().frecUNDSelecStore = null;
    get().frecUNDStore.map((f:any, indexF:any) => {
        f.activo = false 
    }); 
  },
  
}));

export default decisionsStore;
